import { z } from 'zod'

export const saleSchema = z.object({
  title: z
    .string()
    .min(3, 'Title must be at least 3 characters long')
    .max(100, 'Title must be less than 100 characters'),
  description: z
    .string()
    .min(10, 'Description must be at least 10 characters long')
    .max(1000, 'Description must be less than 1000 characters'),
  event_id: z.string().optional(),
  location: z.object({
    address: z.string().min(1, 'Address is required'),
    city: z.string().optional(),
    state: z.string().optional(),
    zip_code: z.string().optional(),
    latitude: z
      .string()
      .optional()
      .refine(
        (val) => {
          // Allow empty strings and undefined
          if (!val || val.trim() === '') return true
          const num = parseFloat(val)
          return !isNaN(num) && num >= -90 && num <= 90
        },
        'Latitude must be between -90 and 90'
      ),
    longitude: z
      .string()
      .optional()
      .refine(
        (val) => {
          // Allow empty strings and undefined
          if (!val || val.trim() === '') return true
          const num = parseFloat(val)
          return !isNaN(num) && num >= -180 && num <= 180
        },
        'Longitude must be between -180 and 180'
      )
  })
}) 